/* PMP_NO_EMAIL_GATE_V2 — Stripe opens immediately; Shopify checkout guard retained. */

(function () {
  var MIDDLEWARE_URL = "https://pmp-stripe-bridge.vercel.app/api/create-checkout";
  var PMP_CUSTOMER_EMAIL = window.PMP_CUSTOMER_EMAIL || null;

  var PMP_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  if (PMP_ROOT.slice(-1) !== "/") PMP_ROOT += "/";
  function pmpRoute(path) { return PMP_ROOT + String(path || "").replace(/^\/+/, ""); }

  var PMP_LOCALE_TAG = String(
    (window.Shopify && Shopify.locale) || document.documentElement.lang || "en"
  ).replace("_", "-");
  var PMP_LANG = PMP_LOCALE_TAG.toLowerCase().split("-")[0];
  var PMP_INTL_LOCALE = {
    fr: "fr-FR", de: "de-DE", es: "es-ES", it: "it-IT", pt: "pt-PT", en: "en-US"
  }[PMP_LANG] || "en-US";

  var PMP_COPY = {
    en: { back: "Back to cart", secure: "Secure checkout", emailCopy: "Enter your email for order updates and checkout recovery.", email: "Email", proceed: "Continue to secure payment", loading: "Loading secure checkout…", subtotal: "Subtotal", total: "Total", upsell: "Complete your order", add: "Add to cart", adding: "Adding…", added: "Added ✓" },
    fr: { back: "Retour au panier", secure: "Paiement sécurisé", emailCopy: "Saisissez votre e-mail pour recevoir les mises à jour de commande et récupérer votre paiement.", email: "E-mail", proceed: "Continuer vers le paiement sécurisé", loading: "Chargement du paiement sécurisé…", subtotal: "Sous-total", total: "Total", upsell: "Complétez votre commande", add: "Ajouter au panier", adding: "Ajout…", added: "Ajouté ✓" },
    de: { back: "Zurück zum Warenkorb", secure: "Sichere Zahlung", emailCopy: "Geben Sie Ihre E-Mail-Adresse für Bestellupdates und zur Wiederherstellung des Bezahlvorgangs ein.", email: "E-Mail", proceed: "Weiter zur sicheren Zahlung", loading: "Sichere Zahlung wird geladen…", subtotal: "Zwischensumme", total: "Gesamt", upsell: "Bestellung ergänzen", add: "In den Warenkorb", adding: "Wird hinzugefügt…", added: "Hinzugefügt ✓" },
    es: { back: "Volver al carrito", secure: "Pago seguro", emailCopy: "Introduce tu correo para recibir novedades del pedido y recuperar el pago.", email: "Correo electrónico", proceed: "Continuar al pago seguro", loading: "Cargando el pago seguro…", subtotal: "Subtotal", total: "Total", upsell: "Completa tu pedido", add: "Añadir al carrito", adding: "Añadiendo…", added: "Añadido ✓" },
    it: { back: "Torna al carrello", secure: "Pagamento sicuro", emailCopy: "Inserisci l’e-mail per gli aggiornamenti sull’ordine e per recuperare il pagamento.", email: "E-mail", proceed: "Continua al pagamento sicuro", loading: "Caricamento del pagamento sicuro…", subtotal: "Subtotale", total: "Totale", upsell: "Completa il tuo ordine", add: "Aggiungi al carrello", adding: "Aggiunta in corso…", added: "Aggiunto ✓" },
    pt: { back: "Voltar ao carrinho", secure: "Pagamento seguro", emailCopy: "Introduza o seu e-mail para receber atualizações da encomenda e recuperar o pagamento.", email: "E-mail", proceed: "Continuar para o pagamento seguro", loading: "A carregar o pagamento seguro…", subtotal: "Subtotal", total: "Total", upsell: "Complete a sua encomenda", add: "Adicionar ao carrinho", adding: "A adicionar…", added: "Adicionado ✓" }
  };
  var PMP_T = PMP_COPY[PMP_LANG] || PMP_COPY.en;

  function pmpCheckoutCountry() {
    var selected = document.querySelector("#PmpHeaderCountrySelectorV3");
    var country = selected && String(selected.value || "").toUpperCase();
    if (/^[A-Z]{2}$/.test(country)) return country;
    var pathMatch = String(window.location.pathname || "").match(/^\/[a-z]{2}-([a-z]{2})(?:\/|$)/i);
    if (pathMatch) return pathMatch[1].toUpperCase();
    var localeMatch = PMP_LOCALE_TAG.match(/^[a-z]{2}-([a-z]{2})$/i);
    return localeMatch ? localeMatch[1].toUpperCase() : null;
  }
  var PMP_CARD_LOGOS =
    '<svg width="36" height="24" viewBox="0 0 36 24" role="img" aria-label="Visa"><rect width="36" height="24" rx="4" fill="#fff" stroke="#e6e6e6"/><text x="18" y="16" font-family="Arial,Helvetica,sans-serif" font-size="10" font-weight="bold" font-style="italic" fill="#1a1f71" text-anchor="middle">VISA</text></svg>' +
    '<svg width="36" height="24" viewBox="0 0 36 24" role="img" aria-label="Mastercard"><rect width="36" height="24" rx="4" fill="#fff" stroke="#e6e6e6"/><circle cx="15" cy="12" r="6.2" fill="#eb001b"/><circle cx="21" cy="12" r="6.2" fill="#f79e1b" fill-opacity="0.85"/></svg>' +
    '<svg width="36" height="24" viewBox="0 0 36 24" role="img" aria-label="American Express"><rect width="36" height="24" rx="4" fill="#1f72cd"/><text x="18" y="15" font-family="Arial,Helvetica,sans-serif" font-size="7" font-weight="bold" fill="#fff" text-anchor="middle">AMEX</text></svg>' +
    '<svg width="36" height="24" viewBox="0 0 36 24" role="img" aria-label="Discover"><rect width="36" height="24" rx="4" fill="#fff" stroke="#e6e6e6"/><text x="14" y="16" font-family="Arial,Helvetica,sans-serif" font-size="7.5" font-weight="bold" fill="#111" text-anchor="middle">DISC</text><circle cx="29" cy="12" r="4.5" fill="#f60"/></svg>';

  function pmpCheckoutCurrency(cart) {
    var country = pmpCheckoutCountry();
    var path = String(window.location.pathname || "").toLowerCase();
    if (country === "CA" || /^\/(?:[a-z]{2}-)?ca(?:\/|$)/.test(path)) return "CAD";
    return String((cart && cart.currency) || "USD").toUpperCase();
  }

  function goCart() { window.location.href = pmpRoute("cart"); }

  function drawerOpen() {
    var sels = [".atlas-upsell-cart-drawer-overlay", ".atlas-upsell-cart-drawer-content",
                "cart-drawer", ".cart-drawer", "#CartDrawer"];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (!el) continue;
      var cs = getComputedStyle(el);
      if (cs.display === "none" || cs.visibility === "hidden") continue;
      if (parseFloat(cs.opacity || "1") < 0.1) continue;
      if (el.getBoundingClientRect().width < 40) continue;
      return true;
    }
    return false;
  }

  function addToCartThenGo(form) {
    try {
      var idInput = form && form.querySelector('input[name="id"], select[name="id"]');
      var variantId = idInput && parseInt(idInput.value, 10);
      if (!variantId) { goCart(); return; }
      fetch(pmpRoute("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: selectedQuantity(form), properties: Object.fromEntries([...new FormData(form)].filter(([key, value]) => /^properties\[.+\]$/.test(key) && typeof value === 'string').map(([key, value]) => [key.slice(11, -1), value])) })
      }).then(waitForDrawer, goCart);
    } catch (e) { goCart(); }
  }

  function anyDrawerElement() {
    var sels = [".atlas-upsell-cart-drawer-overlay", ".atlas-upsell-cart-drawer-content",
                "cart-drawer", ".cart-drawer", "#CartDrawer"];
    for (var i = 0; i < sels.length; i++) { if (document.querySelector(sels[i])) return true; }
    return false;
  }

  function waitForDrawer() {
    if (!anyDrawerElement()) { goCart(); return; }  // no drawer app installed: go straight to the cart
    var t0 = Date.now();
    (function poll() {
      if (drawerOpen()) return;                      // the upsell app took over
      if (Date.now() - t0 > 1500) { goCart(); return; }
      setTimeout(poll, 80);
    })();
  }

  function isNativeShopifyCheckoutUrl(value) {
    if (!value) return false;
    try {
      var url = new URL(value, location.href);
      var shopifyHost = window.Shopify && Shopify.shop
        ? String(Shopify.shop).toLowerCase()
        : "";
      var ownedHost =
        url.origin === location.origin ||
        (shopifyHost && url.hostname.toLowerCase() === shopifyHost);
      return ownedHost && /(^|\/)checkouts?(?:\/|$)/i.test(url.pathname);
    } catch (e) { return false; }
  }

  function isCheckoutControl(el) {
    if (!el || !el.matches) return false;
    if (String(el.getAttribute("name") || "").toLowerCase() === "checkout") return true;
    return isNativeShopifyCheckoutUrl(el.getAttribute("href")) ||
      isNativeShopifyCheckoutUrl(el.getAttribute("formaction"));
  }

  function installNavGuard() {
    if (window.PMP_CHECKOUT_CONFIG?.enabled === true) return;
    if (window.__pmpNavGuard) return; window.__pmpNavGuard = true;

    window.addEventListener("click", function (e) {
      var addBtn = e.target && e.target.closest ? e.target.closest('[name="atlas-bundler-add"]') : null;
      if (addBtn) {
        e.preventDefault(); e.stopImmediatePropagation();
        addToCartThenGo(addBtn.closest("form"));
        return;
      }
      var t = e.target && e.target.closest ? e.target.closest("a,button,input") : null;
      if (t && isCheckoutControl(t)) {
        e.preventDefault(); e.stopImmediatePropagation();
        goCart();
      }
    }, true);

    window.addEventListener("submit", function (e) {
      var f = e.target;
      var action = f && f.getAttribute ? (f.getAttribute("action") || "") : "";
      if (isNativeShopifyCheckoutUrl(action)) {
        e.preventDefault(); e.stopImmediatePropagation();
        goCart();
      }
    }, true);

    try {
      var isCk = isNativeShopifyCheckoutUrl;
      var A = window.location.assign.bind(window.location);
      var R = window.location.replace.bind(window.location);
      window.location.assign = function (u) { return isCk(u) ? A(pmpRoute("cart")) : A(u); };
      window.location.replace = function (u) { return isCk(u) ? R(pmpRoute("cart")) : R(u); };
    } catch (_) {}
  }
  installNavGuard();

  var STRIPE_PUBLISHABLE_KEY = "pk_live_51LkGnuA0auDoBNzs5k9d198IPpnNqBAf31rLvJ4WBstIc553lEVA4GRB3TfRCSXWQT1UBeuRJO6QYqP3RlMEvRzm00iRCwtZYD";
  var STORE_NAME = "Pure Majesty Pets";
  var META_PIXEL_ID = "3335888619952673";
  var PMP_CROWN = '<svg class="pmp-crown" viewBox="0 0 24 20" aria-hidden="true"><path d="M2.5 16 L5 5 L9 10.5 L12 3 L15 10.5 L19 5 L21.5 16 Z" fill="#bf9b30"/><circle cx="5" cy="5" r="1.5" fill="#bf9b30"/><circle cx="12" cy="3" r="1.6" fill="#bf9b30"/><circle cx="19" cy="5" r="1.5" fill="#bf9b30"/><rect x="4" y="16.2" width="16" height="2" rx="1" fill="#bf9b30"/></svg>';

  var pmpCheckout = null;
  var pmpCart = null;
  var pmpStripe = null;
  var pmpCheckoutSessionId = null;

  // Identite GA4 : deux sources volontairement combinees.
  // Source primaire = l'API gtag get, recommandee par Google et insensible aux
  // changements de format du cookie (le format _ga_<ID> a deja change une fois).
  // Elle est asynchrone : on la precharge dans ce cache, on la lit au clic.
  // Repli = parsing des cookies _ga / _ga_KKS5T7SPHR, qui couvre le cas ou la balise
  // Google n'est pas encore prete (app Google & YouTube injectee en asynchrone).
  var pmpGaIds = { client_id: null, session_id: null, session_number: null };
  function pmpPrimeGaIds(onEach) {
    function ack() { try { if (onEach) onEach(); } catch (e) {} }
    try {
      if (!window.gtag) return;
      gtag('get', 'G-KKS5T7SPHR', 'client_id', function (v) { if (v) pmpGaIds.client_id = String(v); ack(); });
      gtag('get', 'G-KKS5T7SPHR', 'session_id', function (v) { if (v) pmpGaIds.session_id = String(v); ack(); });
      gtag('get', 'G-KKS5T7SPHR', 'session_number', function (v) { if (v) pmpGaIds.session_number = String(v); ack(); });
    } catch (e) {}
  }
  // Rafraichit l'identite GA4 juste avant /create-checkout : sur une page laissee
  // longtemps ouverte, le session_id GA4 change et le cache deviendrait perime.
  // Delai de garde volontairement court (300 ms) : imperceptible au moment du clic
  // (le rendu du checkout Stripe qui suit coute bien davantage), mais largement
  // suffisant pour un callback gtag qui est resolu en memoire, sans appel reseau.
  // Cette promesse ne rejette jamais et ne reste jamais en suspens : absence de
  // gtag, callback muet, exception ou setTimeout indisponible => resolution
  // immediate et on continue avec le cache existant puis le repli cookie.
  // Un echec de mesure ne doit jamais empecher un client de payer.
  function pmpRefreshGaIds() {
    try {
      return new Promise(function (resolve) {
        var settled = false;
        var pending = 3;
        var timer = null;
        function finish() {
          if (settled) return;
          settled = true;
          if (timer) { try { clearTimeout(timer); } catch (e) {} timer = null; }
          resolve();
        }
        try {
          if (!window.gtag) { finish(); return; }
          timer = setTimeout(finish, 300);
          pmpPrimeGaIds(function () { pending -= 1; if (pending <= 0) finish(); });
        } catch (e) { finish(); }
      });
    } catch (e) { return Promise.resolve(); }
  }
  pmpPrimeGaIds();
  // Second passage differe : la balise Google peut etre injectee apres ce script.
  try { setTimeout(pmpPrimeGaIds, 3000); } catch (e) {}

  var pmpStripeJsPromise = null;
  function loadStripeJs() {
    if (window.Stripe) return Promise.resolve(window.Stripe);
    if (pmpStripeJsPromise) return pmpStripeJsPromise;
    pmpStripeJsPromise = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        pmpStripeJsPromise = null;
        try { s.remove(); } catch (e) {}
        reject(new Error("Stripe took too long to load."));
      }, 12000);
      s.src = "https://js.stripe.com/v3/";
      s.onload = function () {
        if (settled) return;
        settled = true; clearTimeout(timer);
        if (window.Stripe) resolve(window.Stripe);
        else { pmpStripeJsPromise = null; reject(new Error("Stripe failed to load.")); }
      };
      s.onerror = function () {
        if (settled) return;
        settled = true; clearTimeout(timer); pmpStripeJsPromise = null;
        reject(new Error("Could not load Stripe."));
      };
      document.head.appendChild(s);
    });
    return pmpStripeJsPromise;
  }

  function fallbackToShopifyCheckout(error) {
    try { console.error("Embedded Stripe checkout unavailable", error); } catch (e) {}
    alert("The secure Stripe payment window could not start. Please try again.");
  }

  var pmpWarmed = false;
  function pmpWarm() {
    if (window.PMP_CHECKOUT_CONFIG?.enabled === true) return;
    if (pmpWarmed) return; pmpWarmed = true;
    ["https://js.stripe.com", "https://m.stripe.com", "https://api.stripe.com", "https://pmp-stripe-bridge.vercel.app"].forEach(function (h) {
      var l = document.createElement("link"); l.rel = "preconnect"; l.href = h; l.crossOrigin = ""; document.head.appendChild(l);
    });
    loadStripeJs().catch(function () {});                     // preload Stripe.js
    try { fetch(MIDDLEWARE_URL, { method: "OPTIONS" }).catch(function () {}); } catch (e) {} // wake the Vercel function (no session created)
  }
  function pmpIntent(e) {
    var t = e.target && e.target.closest ? e.target.closest('.pmp-pay-btn, [name="atlas-bundler-add"], [name="add"], [name="checkout"]') : null;
    if (t) pmpWarm();
  }
  window.addEventListener("pointerover", pmpIntent, { capture: true, passive: true });
  window.addEventListener("pointerdown", pmpIntent, { capture: true, passive: true });

  function pmpCookie(name) {
    var m = document.cookie.match(new RegExp("(^|;\\s*)" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function pmpSafePageUrl(value) {
    try {
      var u = new URL(value, location.href);
      if (u.protocol !== "https:" && u.protocol !== "http:") return null;
      return (u.origin + u.pathname).slice(0, 500);
    } catch (e) { return null; }
  }

  function pmpAttribution() {
    var currentUrl = location.href;
    var firstUrl = currentUrl;
    var firstReferrer = document.referrer || "";
    try {
      firstUrl = sessionStorage.getItem("pmp_landing_url") || currentUrl;
      firstReferrer = sessionStorage.getItem("pmp_first_referrer") || firstReferrer;
      if (!sessionStorage.getItem("pmp_landing_url")) sessionStorage.setItem("pmp_landing_url", firstUrl);
      if (!sessionStorage.getItem("pmp_first_referrer")) sessionStorage.setItem("pmp_first_referrer", firstReferrer);
    } catch (e) {}

    var q;
    try { q = new URL(firstUrl, location.href).searchParams; }
    catch (e) { q = new URLSearchParams(location.search); }

    var fbc = pmpCookie("_fbc");
    var fbclid = q.get("fbclid");
    if (!fbc && fbclid) {
      fbc = "fb.1." + Date.now() + "." + fbclid;
      try {
        document.cookie = "_fbc=" + encodeURIComponent(fbc) + "; Max-Age=7776000; Path=/; SameSite=Lax; Secure";
      } catch (e) {}
    }

    var gaClientId = null;
    try {
      var gaCookie = pmpCookie("_ga");
      if (gaCookie) {
        var gaParts = String(gaCookie).split(".");
        if (gaParts.length >= 4) {
          gaClientId = gaParts.slice(-2).join(".") || null;
        }
      }
    } catch (e) { gaClientId = null; }

    var gaSessionId = null;
    var gaSessionNumber = null;
    try {
      var gaSessionCookie = pmpCookie("_ga_KKS5T7SPHR");
      if (gaSessionCookie) {
        var gaSessionParts = String(gaSessionCookie).split(".");
        if (gaSessionParts.length >= 3 && gaSessionParts[2].indexOf("$") !== -1) {
          // recent format: GS2.1.s1700000000$o3$g1$t1700000000$j0$l0$h0
          var gaFields = gaSessionParts[2].split("$");
          for (var gaK = 0; gaK < gaFields.length; gaK++) {
            var gaF = gaFields[gaK];
            if (gaSessionId === null && gaF.charAt(0) === "s") gaSessionId = gaF.slice(1) || null;
            else if (gaSessionNumber === null && gaF.charAt(0) === "o") gaSessionNumber = gaF.slice(1) || null;
          }
        } else if (gaSessionParts.length >= 3) {
          // legacy format: GS1.1.<session_id>.<session_number>....
          gaSessionId = gaSessionParts[2] || null;
          gaSessionNumber = gaSessionParts.length >= 4 ? (gaSessionParts[3] || null) : null;
        }
      }
    } catch (e) { gaSessionId = null; gaSessionNumber = null; }

    return {
      fbp: pmpCookie("_fbp"),
      fbc: fbc,
      external_id: pmpUid(),
      landing_url: pmpSafePageUrl(firstUrl),
      referrer: pmpSafePageUrl(firstReferrer),
      utm_source: q.get("utm_source"),
      utm_medium: q.get("utm_medium"),
      utm_campaign: q.get("utm_campaign"),
      utm_content: q.get("utm_content"),
      utm_term: q.get("utm_term"),
      gclid: q.get("gclid"),
      gbraid: q.get("gbraid"),
      wbraid: q.get("wbraid"),
      ttclid: q.get("ttclid"),
      msclkid: q.get("msclkid"),
      ga_client_id: pmpGaIds.client_id || gaClientId || null,
      ga_session_id: pmpGaIds.session_id || gaSessionId || null,
      ga_session_number: pmpGaIds.session_number || gaSessionNumber || null
    };
  }

  function pmpUid() {
    try {
      var v = localStorage.getItem("pmp_uid");
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : "u" + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
        localStorage.setItem("pmp_uid", v);
      }
      return v;
    } catch (e) { return null; }
  }
  function pmpEmail(set) {
    try {
      if (set) { localStorage.setItem("pmp_em", String(set).trim().toLowerCase()); return; }
      return localStorage.getItem("pmp_em");
    } catch (e) { return null; }
  }
  function pmpApplyIdentity() {
    try {
      if (!window.fbq || !META_PIXEL_ID) return;
      var am = {};
      var uid = pmpUid(); if (uid) am.external_id = uid;
      var em = pmpEmail(); if (em) am.em = em;
      if (Object.keys(am).length) fbq("init", META_PIXEL_ID, am);
    } catch (e) {}
  }
  pmpApplyIdentity();
  setTimeout(pmpApplyIdentity, 1500);
  setTimeout(pmpApplyIdentity, 4000);

  window.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.type === "email" && t.value && t.value.indexOf("@") > 0) {
      pmpEmail(t.value); pmpApplyIdentity();
    }
  }, true);

  function pmpTrackPurchase() {
    if (!/(^|\/)(pages\/)?thank-you(\/|$)/.test(location.pathname)) return;
    var sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) return;
    var KEY = "pmp_purch_" + sid;
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}

    function fireAll(value, cur) {
      try { localStorage.setItem(KEY, "1"); } catch (e) {}
      try {
        if (window.fbq) {
          fbq("trackSingle", META_PIXEL_ID, "Purchase", {
            value: value, currency: cur, content_type: "product", order_id: sid
          }, { eventID: sid }); // same id as the server CAPI event → deduped
        }
      } catch (e) {}
      // GA4 purchase moved server-side on 2026-08-11. The browser event only
      // fired if the customer actually loaded the thank-you page, so paid
      // orders whose buyer closed the tab produced no conversion at all
      // (order #1565 among them). The Stripe webhook now sends it through the
      // Measurement Protocol with the same transaction_id (the Stripe session
      // id), plus the GA4 client_id and session_id captured at checkout, so
      // the purchase lands in the session that carried the ad click.
      // Do not re-add a browser purchase here: it would double-count.
      // Google Ads conversion tag removed on 2026-08-10. It pointed at
      // AW-18031615333, an account that runs no campaigns. The account that
      // does — 659-120-5737 — imports its Purchase conversion from GA4, so the
      // gtag("event","purchase") call just above is what actually feeds it.
      // Firing a second event at a third-party account only added noise.
      // If a native Ads tag is ever wanted, add the label of AW-18378822064.
      try { if (window.ttq) ttq.track("CompletePayment", { value: value, currency: cur, content_type: "product" }); } catch (e) {}
    }

    fetch(MIDDLEWARE_URL.replace("/create-checkout", "/session-status") + "?session_id=" + encodeURIComponent(sid), { keepalive: true })
      .then(function (r) { if (!r.ok) throw new Error("Could not verify payment."); return r.json(); })
      .then(function (d) {
        if (!d || !d.paid) return;
        var verifiedValue = (Number(d.amount) || 0) / 100;
        var verifiedCurrency = d.currency || "USD";
        try {
          if (window.clarity) {
            clarity("set", "purchase", "true");
            clarity("set", "stripe_session", sid);
            clarity("set", "order_currency", verifiedCurrency);
            clarity("set", "order_value", String(verifiedValue));
            clarity("identify", sid, sid, "thank-you", "Order " + sid.slice(-8));
            clarity("event", "purchase");
            clarity("upgrade", "purchase");
          }
        } catch (e) {}
        fireAll(verifiedValue, verifiedCurrency);
      })
      .catch(function () {});
  }
  pmpTrackPurchase();

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function money(cents, currency) {
    var v = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat(PMP_INTL_LOCALE, { style: "currency", currency: currency || "USD" }).format(v); }
    catch (e) { return "$" + v.toFixed(2); }
  }
  function renderSummary(cart) {
    var el = document.getElementById("pmp-summary");
    if (!el) return;
    var cur = cart.currency || "USD";
    var rows = (cart.items || []).map(function (i, idx) {
      var img = i.image ? String(i.image) : "";
      if (img.indexOf("//") === 0) img = "https:" + img;
      var variant = (i.variant_title && i.variant_title !== "Default Title") ? i.variant_title : "";
      var line = idx + 1;                       // /cart/change.js line index is 1-based
      var qty = i.quantity || 1;
      return '<div class="pmp-sum-item">' +
          '<div class="pmp-sum-thumb" style="background-image:url(\'' + img + '\')"><span class="pmp-sum-qty">' + qty + '</span></div>' +
          '<div class="pmp-sum-info"><div class="pmp-sum-title">' + escapeHtml(i.product_title) + '</div>' +
            (variant ? '<div class="pmp-sum-variant">' + escapeHtml(variant) + '</div>' : '') +
            '<div class="pmp-sum-edit">' +
              '<button type="button" class="pmp-qty-btn" data-line="' + line + '" data-qty="' + (qty - 1) + '"' + (qty <= 1 ? " disabled" : "") + ' aria-label="Decrease quantity">&minus;</button>' +
              '<span class="pmp-qty-val">' + qty + '</span>' +
              '<button type="button" class="pmp-qty-btn" data-line="' + line + '" data-qty="' + (qty + 1) + '" aria-label="Increase quantity">+</button>' +
              '<button type="button" class="pmp-line-remove" data-line="' + line + '" data-qty="0">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="pmp-sum-price">' + money(i.final_line_price, cur) + '</div>' +
        '</div>';
    }).join("");
    el.innerHTML = rows +
      '<div class="pmp-sum-totals">' +
        '<div class="pmp-sum-row"><span>' + escapeHtml(PMP_T.subtotal) + '</span><span>' + money(cart.items_subtotal_price, cur) + '</span></div>' +
        '<div class="pmp-sum-row pmp-sum-total"><span>' + escapeHtml(PMP_T.total) + '</span><span>' + money(cart.total_price, cur) + ' ' + cur + '</span></div>' +
      '</div>' +
      '<div id="pmp-suggest"></div>';

    el.querySelectorAll("[data-line]").forEach(function (b) {
      b.addEventListener("click", function () {
        changeLine(parseInt(b.getAttribute("data-line"), 10), parseInt(b.getAttribute("data-qty"), 10));
      });
    });
  }

  var pmpCartBusy = false;
  async function changeLine(line, quantity) {
    if (pmpCartBusy) return;
    pmpCartBusy = true;
    var panel = document.getElementById("pmp-summary");
    if (panel) panel.classList.add("pmp-sum-busy");
    try {
      var r = await fetch(pmpRoute("cart/change.js"), {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!r.ok) throw new Error("Could not update the cart.");
      pmpCart = await r.json();
      if (!pmpCart.items || !pmpCart.items.length) {
        closeOverlay();
        goCart();
        return;
      }
      renderSummary(pmpCart);
      renderSuggestions(pmpCart);
      await mountCheckout(pmpCart);
    } catch (e) {
      alert(e.message || "Could not update the cart.");
    } finally {
      pmpCartBusy = false;
      var p2 = document.getElementById("pmp-summary");
      if (p2) p2.classList.remove("pmp-sum-busy");
    }
  }

  function renderSuggestions(cart) {
    var el = document.getElementById("pmp-suggest");
    if (!el) return;
    var pid = cart.items && cart.items[0] && cart.items[0].product_id;
    if (!pid) { el.innerHTML = ""; return; }
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var cur = cart.currency || "USD";
    fetch(pmpRoute("recommendations/products.json?product_id=" + pid + "&limit=6"))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) { return p.available && !inCart[p.id]; }).slice(0, 2);
        if (!prods.length) { el.innerHTML = ""; return; }
        el.innerHTML = '<div class="pmp-sug-title">' + escapeHtml(PMP_T.upsell) + '</div>' + prods.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          if (!v) return "";
          var img = p.featured_image ? String(p.featured_image) : "";
          if (img.indexOf("//") === 0) img = "https:" + img;
          return '<div class="pmp-sug-item">' +
              '<div class="pmp-sum-thumb" style="background-image:url(\'' + img + '\')"></div>' +
              '<div class="pmp-sum-info"><div class="pmp-sum-title">' + escapeHtml(p.title) + '</div>' +
                '<div class="pmp-sum-variant">' + money(v.price, cur) + '</div></div>' +
              '<button type="button" class="pmp-sug-add" data-vid="' + v.id + '" data-price="' + v.price + '" data-title="' + escapeHtml(p.title) + '">' + escapeHtml(PMP_T.add) + '</button>' +
            '</div>';
        }).join("");
        try {
          if (window.clarity) clarity("event", "upsell_shown");
          if (window.gtag) gtag("event", "view_promotion", { promotion_name: "Complete your look", items: prods.map(function(p){ return { item_id: String(p.id), item_name: p.title }; }) });
        } catch (e) {}
        el.querySelectorAll(".pmp-sug-add").forEach(function (b) {
          b.addEventListener("click", function () {
            addUpsell(parseInt(b.getAttribute("data-vid"), 10), b, {
              price: (Number(b.getAttribute("data-price")) || 0) / 100,
              title: b.getAttribute("data-title") || "",
              currency: cur
            });
          });
        });
      })
      .catch(function () { el.innerHTML = ""; });
  }

  async function addUpsell(variantId, btn, meta) {
    var t = btn.textContent; btn.disabled = true; btn.textContent = PMP_T.adding;
    try {
      var addRes = await fetch(pmpRoute("cart/add.js"), {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!addRes.ok) throw new Error("Could not add this product.");

      try {
        var uv = (meta && meta.price) || 0, uc = (meta && meta.currency) || "USD";
        if (window.fbq) {
          fbq("trackSingle", META_PIXEL_ID, "AddToCart", {
            value: uv, currency: uc, content_type: "product",
            content_ids: [String(variantId)], content_name: (meta && meta.title) || undefined
          });
          fbq("trackSingleCustom", META_PIXEL_ID, "UpsellAccepted", {
            value: uv, currency: uc, content_ids: [String(variantId)], content_name: (meta && meta.title) || undefined
          });
        }
        if (window.gtag) gtag("event", "select_promotion", {
          promotion_name: "Complete your look", value: uv, currency: uc,
          items: [{ item_id: String(variantId), item_name: (meta && meta.title) || "" }]
        });
        if (window.clarity) {
          clarity("event", "upsell_accepted");
          clarity("set", "upsell_accepted", "true");
          clarity("set", "upsell_product", (meta && meta.title) || String(variantId));
        }
      } catch (e) {}
      pmpCart = await (await fetch(pmpRoute("cart.js"))).json();
      renderSummary(pmpCart);
      renderSuggestions(pmpCart);
      await mountCheckout(pmpCart);
    } catch (e) {
      btn.disabled = false; btn.textContent = t;
      alert(e.message || "Could not add this product.");
    }
  }


  function pmpValidEmail(value) {
    var email = String(value || "").trim().toLowerCase();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && email.length <= 254 ? email : null;
  }

  function pmpAbsoluteUrl(value) {
    try {
      if (!value) return null;
      var url = new URL(String(value), location.origin);
      if (url.protocol !== "http:" && url.protocol !== "https:") return null;
      url.hash = "";
      return url.href;
    } catch (e) { return null; }
  }

  function pmpBaseCartToken(cart) {
    return String((cart && cart.token) || "").split("?")[0].slice(0, 200);
  }

  function pmpEventUuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
    } catch (e) {}
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === "x" ? r : (r & 3 | 8)).toString(16);
    });
  }

  function pmpRecoveryUrl(data) {
    var provided = pmpAbsoluteUrl(data && data.abandonedCheckoutURL);
    return provided || new URL("/cart", location.origin).href;
  }

  function pmpOmnisendPayload(cart, data) {
    var currency = String(data.currency || pmpCheckoutCurrency(cart) || cart.currency || "USD").toUpperCase();
    var value = Number(data.amountTotal);
    value = isFinite(value) ? value / 100 : (Number(cart.total_price) || 0) / 100;
    return {
      origin: "api",
      eventID: data.omnisendEventId || pmpEventUuid(),
      eventVersion: "",
      properties: {
        abandonedCheckoutURL: pmpRecoveryUrl(data),
        cartID: pmpBaseCartToken(cart) || String(data.sessionId),
        currency: currency,
        value: value,
        lineItems: (cart.items || []).map(function (item) {
          var line = {
            productID: String(item.product_id || item.variant_id),
            productVariantID: String(item.variant_id),
            productTitle: String(item.product_title || item.title || ""),
            productPrice: (Number(item.final_price || item.price) || 0) / 100,
            productQuantity: Number(item.quantity) || 1
          };
          var productUrl = pmpAbsoluteUrl(item.url);
          var imageUrl = pmpAbsoluteUrl(item.image);
          if (productUrl) line.productURL = productUrl;
          if (imageUrl) {
            line.productImageURL = imageUrl;
            line.productVariantImageURL = imageUrl;
          }
          if (item.sku) line.productSKU = String(item.sku);
          return line;
        })
      },
      contact: { email: pmpValidEmail(PMP_CUSTOMER_EMAIL) }
    };
  }

  function pmpPushOmnisendStarted(cart, data, startedAt) {
    var marker = "pmp_omni_started:" + String(data.sessionId || "");
    try {
      if (data.omnisendStarted === true) {
        sessionStorage.setItem(marker, startedAt);
        return;
      }
      if (sessionStorage.getItem(marker)) return;
    } catch (e) {}
    if (!pmpValidEmail(PMP_CUSTOMER_EMAIL)) return;
    try {
      window.omnisend = window.omnisend || [];
      if (typeof window.omnisend.push !== "function") return;
      window.omnisend.push(["track", "started checkout", pmpOmnisendPayload(cart, data)]);
      try { sessionStorage.setItem(marker, startedAt); } catch (e) {}
    } catch (e) {
      try { console.warn("Omnisend checkout event failed", e); } catch (_) {}
    }
  }

  function pmpWriteBridgeAttributes(data, startedAt) {
    fetch(pmpRoute("cart/update.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        attributes: {
          pmp_bridge_session: String(data.sessionId),
          pmp_bridge_state: "session_created",
          pmp_bridge_started_at: startedAt
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart attributes HTTP " + response.status);
      return response.json();
    }).then(function (updatedCart) {
      if (updatedCart && updatedCart.items) pmpCart = updatedCart;
    }).catch(function (error) {
      try { console.warn("Bridge cart attributes failed", error); } catch (_) {}
    });
  }

  function pmpRecordBridgeStarted(cart, data) {
    var startedAt = new Date().toISOString();
    var currency = String(data.currency || pmpCheckoutCurrency(cart) || cart.currency || "USD").toUpperCase();
    var value = Number(data.amountTotal);
    value = isFinite(value) ? value / 100 : (Number(cart.total_price) || 0) / 100;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        var published = Shopify.analytics.publish("pmp_stripe_checkout_started", {
          session_id: String(data.sessionId),
          cart_id: pmpBaseCartToken(cart),
          recovery_url: pmpRecoveryUrl(data),
          currency: currency,
          value: value
        });
        if (published && typeof published.catch === "function") published.catch(function () {});
      }
    } catch (e) {}
    pmpPushOmnisendStarted(cart, data, startedAt);
    pmpWriteBridgeAttributes(data, startedAt);
  }


  var pmpCheckoutEventSeen = Object.create(null);

  function pmpCheckoutEventText(value, fallback, maxLength) {
    var clean = String(value == null ? "" : value).trim();
    if (!clean) clean = fallback || "";
    return clean.slice(0, maxLength || 100);
  }

  function pmpCheckoutEventPayload(cart, data) {
    data = data || {};
    var source = data.analytics && data.analytics.beginCheckout;
    source = source || {};
    var sessionId = pmpCheckoutEventText(data.sessionId, "", 100);
    if (!sessionId || !/^[A-Za-z0-9_-]+$/.test(sessionId)) return null;

    var eventId = pmpCheckoutEventText(source.eventId, "pmp_begin_checkout_" + sessionId, 100);
    if (!/^[A-Za-z0-9:_-]+$/.test(eventId)) return null;

    var currency = pmpCheckoutEventText(
      source.currency || data.currency || pmpCheckoutCurrency(cart) || (cart && cart.currency),
      "USD",
      3
    ).toUpperCase();
    if (!/^[A-Z]{3}$/.test(currency)) return null;

    var value = Number(source.value);
    if (!isFinite(value) || value < 0) {
      var amountTotal = Number(data.amountTotal);
      value = isFinite(amountTotal) && amountTotal >= 0
        ? amountTotal / 100
        : (Number(cart && cart.total_price) || 0) / 100;
    }
    value = Number(value.toFixed(2));

    var rawItems = Array.isArray(source.items) && source.items.length
      ? source.items
      : ((cart && cart.items) || []).map(function (item) {
          return {
            item_id: String(item.variant_id || item.id || ""),
            item_name: item.product_title || item.title || "Item",
            price: (Number(item.final_price || item.price) || 0) / 100,
            quantity: Number(item.quantity) || 1
          };
        });
    var items = rawItems.map(function (item) {
      item = item || {};
      var price = Number(item.price);
      var quantity = Number(item.quantity);
      return {
        item_id: pmpCheckoutEventText(item.item_id, "unknown", 100),
        item_name: pmpCheckoutEventText(item.item_name, "Item", 250),
        price: isFinite(price) && price >= 0 ? Number(price.toFixed(2)) : 0,
        quantity: Math.floor(quantity) > 0 ? Math.floor(quantity) : 1
      };
    }).filter(function (item) {
      return item.item_id !== "unknown" || item.item_name !== "Item";
    });
    if (!items.length) return null;

    return {
      session_id: sessionId,
      event_id: eventId,
      currency: currency,
      value: value,
      items: items
    };
  }

  function pmpCheckoutEventStored(key) {
    if (pmpCheckoutEventSeen[key]) return true;
    try { return sessionStorage.getItem(key) === "1"; }
    catch (e) { return false; }
  }

  function pmpStoreCheckoutEvent(key) {
    pmpCheckoutEventSeen[key] = true;
    try { sessionStorage.setItem(key, "1"); } catch (e) {}
  }

  function pmpGtagEvent(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== "function") {
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      window.gtag("event", name, params);
    } catch (e) {}
  }

  function pmpTrackBeginCheckout(cart, data) {
    var payload = pmpCheckoutEventPayload(cart, data);
    if (!payload) return false;
    var eventKey = "pmp:checkout-event:begin_checkout:event:" + payload.event_id;
    var sessionKey = "pmp:checkout-event:begin_checkout:session:" + payload.session_id;
    if (pmpCheckoutEventStored(eventKey) || pmpCheckoutEventStored(sessionKey)) return false;

    pmpStoreCheckoutEvent(eventKey);
    pmpStoreCheckoutEvent(sessionKey);
    pmpGtagEvent("begin_checkout", {
      event_id: payload.event_id,
      currency: payload.currency,
      value: payload.value,
      items: payload.items
    });
    try {
      if (window.clarity) {
        clarity("set", "pmp_checkout_event_id", payload.event_id);
        clarity("set", "stripe_session", payload.session_id);
        clarity("set", "checkout_currency", payload.currency);
        clarity("set", "checkout_value", String(payload.value));
        clarity("event", "begin_checkout");
      }
    } catch (e) {}
    return true;
  }

  function pmpTrackCheckoutError(stage, error) {
    var cleanStage = pmpCheckoutEventText(stage, "unknown", 40).replace(/[^A-Za-z0-9_-]/g, "_");
    var rawCode = error && (error.code || error.status || error.name);
    var cleanCode = pmpCheckoutEventText(rawCode, "unknown", 80).replace(/[^A-Za-z0-9_-]/g, "_");
    try {
      if (window.clarity) {
        clarity("set", "pmp_checkout_error_stage", cleanStage);
        clarity("set", "pmp_checkout_error_code", cleanCode);
        clarity("event", "checkout_error");
      }
    } catch (e) {}
  }

  async function mountCheckout(cart) {
    var pmpCreatedCheckoutData = null;
    try { if (pmpCheckout) pmpCheckout.destroy(); } catch (e) {}
    pmpCheckout = null;
    var host = document.getElementById("pmp-embedded");
    if (host) host.innerHTML = '<div class="pmp-ov-loading">' + escapeHtml(PMP_T.loading) + '</div>';
    if (!pmpStripe) pmpStripe = window.Stripe(STRIPE_PUBLISHABLE_KEY);
    var fetchClientSecret = function () {
      var items = cart.items.map(function (i) {
        return {
          variant_id: i.variant_id,
          title: i.product_title,
          quantity: i.quantity,
          price_cents: i.final_price,
          image: i.image,
          product_id: i.product_id,
          url: pmpAbsoluteUrl(i.url)
        };
      });
      return pmpRefreshGaIds().then(function () {
        var attribution = pmpAttribution();
        return fetch(MIDDLEWARE_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: items,
            currency: pmpCheckoutCurrency(cart),
            checkout_country: pmpCheckoutCountry(),
            locale: PMP_LOCALE_TAG,
            note: cart.note || "",
            email: pmpValidEmail(PMP_CUSTOMER_EMAIL),
            shopify_cart_token: pmpBaseCartToken(cart),
            shopify_cart_url: pmpRecoveryUrl({}),
            fbp: attribution.fbp,
            fbc: attribution.fbc,
            external_id: attribution.external_id,
            landing_url: attribution.landing_url,
            referrer: attribution.referrer,
            utm_source: attribution.utm_source,
            utm_medium: attribution.utm_medium,
            utm_campaign: attribution.utm_campaign,
            utm_content: attribution.utm_content,
            utm_term: attribution.utm_term,
            gclid: attribution.gclid,
            gbraid: attribution.gbraid,
            wbraid: attribution.wbraid,
            ttclid: attribution.ttclid,
            msclkid: attribution.msclkid,
            ga_client_id: attribution.ga_client_id,
            ga_session_id: attribution.ga_session_id,
            ga_session_number: attribution.ga_session_number
          })
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (!d.clientSecret || !d.sessionId) throw new Error(d.error || "Could not start checkout.");
          pmpCheckoutSessionId = String(d.sessionId);
          pmpCreatedCheckoutData = d;
          pmpRecordBridgeStarted(cart, d);
          try {
            if (window.clarity && pmpCheckoutSessionId) {
              clarity("set", "stripe_session_created", "true");
              clarity("set", "stripe_session", pmpCheckoutSessionId);
              clarity("event", "stripe_session_created");
            }
            if (window.gtag) gtag("event", "checkout_session_created", {
              currency: cart.currency || "USD",
              value: (Number(cart.total_price) || 0) / 100
            });
          } catch (e) {}
          return d.clientSecret;
        });
      });
    };
    pmpCheckout = await pmpStripe.initEmbeddedCheckout({ fetchClientSecret: fetchClientSecret });
    if (host) host.innerHTML = "";
    pmpCheckout.mount("#pmp-embedded");
    return pmpCreatedCheckoutData;
  }

  function closeOverlay() {
    try { if (pmpCheckout) pmpCheckout.destroy(); } catch (e) {}
    pmpCheckout = null;
    var o = document.getElementById("pmp-overlay");
    if (o) o.remove();
    document.documentElement.style.overflow = "";
  }

  function buildOverlay() {
    var o = document.createElement("div");
    o.id = "pmp-overlay";
    o.innerHTML =
      '<div class="pmp-ov-bar">' +
        '<button type="button" class="pmp-ov-back">&larr; ' + escapeHtml(PMP_T.back) + '</button>' +
        '<span class="pmp-ov-secure">' + PMP_CROWN + STORE_NAME + '</span>' +
      '</div>' +
      '<div class="pmp-ov-body">' +
        '<div class="pmp-ov-main">' +
          '<form id="pmp-email-gate" class="pmp-email-gate" hidden novalidate>' +
            '<h2>' + escapeHtml(PMP_T.secure) + '</h2>' +
            '<p class="pmp-email-copy">' + escapeHtml(PMP_T.emailCopy) + '</p>' +
            '<label for="pmp-checkout-email">' + escapeHtml(PMP_T.email) + '</label>' +
            '<input id="pmp-checkout-email" type="email" autocomplete="email" inputmode="email" autocapitalize="none" spellcheck="false" required>' +
            '<p id="pmp-email-error" class="pmp-email-error" aria-live="polite"></p>' +
            '<button type="submit" class="pmp-email-continue">' + escapeHtml(PMP_T.proceed) + '</button>' +
          '</form>' +
          '<div id="pmp-embedded"></div>' +
        '</div>' +
        '<aside class="pmp-ov-summary" id="pmp-summary"></aside>' +
      '</div>';
    document.body.appendChild(o);
    o.querySelector(".pmp-ov-back").addEventListener("click", function () {
      closeOverlay();
      if (!/\/cart\/?$/.test(location.pathname)) goCart();
    });
    document.documentElement.style.overflow = "hidden";
    return o;
  }


  function showEmailGate(cart) {
    var gate = document.getElementById("pmp-email-gate");
    var host = document.getElementById("pmp-embedded");
    if (!gate || !host) throw new Error("Email step is unavailable.");
    var input = gate.querySelector("#pmp-checkout-email");
    var error = gate.querySelector("#pmp-email-error");
    var button = gate.querySelector(".pmp-email-continue");
    host.hidden = true;
    gate.hidden = false;
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 50);
    gate.addEventListener("submit", function (event) {
      event.preventDefault();
      if (button.disabled) return;
      var email = pmpValidEmail(input.value);
      if (!email) {
        input.setAttribute("aria-invalid", "true");
        error.textContent = "Enter a valid email address.";
        input.focus();
        return;
      }
      PMP_CUSTOMER_EMAIL = email;
      input.removeAttribute("aria-invalid");
      error.textContent = "";
      button.disabled = true;
      gate.hidden = true;
      host.hidden = false;
      host.innerHTML = '<div class="pmp-ov-loading">' + escapeHtml(PMP_T.loading) + '</div>';
      loadStripeJs().then(function () {
        if (!document.getElementById("pmp-overlay")) return;
        return mountCheckout(cart);
      }).catch(function (checkoutError) {
        if (!document.getElementById("pmp-overlay")) return;
        closeOverlay();
        fallbackToShopifyCheckout(checkoutError);
      });
    });
  }

  async function openEmbedded() {
    if (window.PMP_CHECKOUT_CONFIG?.enabled === true) {
      if (!window.PMPCheckout) throw new Error('Checkout bridge unavailable');
      return window.PMPCheckout.start();
    }
    pmpCheckoutSessionId = null;
    try {
      var cartResponse = await fetch(pmpRoute("cart.js"));
      if (!cartResponse.ok) throw new Error("Could not read the cart.");
      pmpCart = await cartResponse.json();
      if (!pmpCart.items || !pmpCart.items.length) { alert("Your cart is empty — add a product first."); return; }
      if (String(STRIPE_PUBLISHABLE_KEY).indexOf("pk_") !== 0) throw new Error("Checkout isn't configured yet (missing Stripe key).");

      try {
        var icV = (Number(pmpCart.total_price) || 0) / 100;
        var icC = pmpCart.currency || "USD";
        var icIds = pmpCart.items.map(function (i) { return String(i.variant_id); });
        var icN = pmpCart.items.reduce(function (n, i) { return n + (Number(i.quantity) || 1); }, 0);
        if (window.fbq) fbq("trackSingle", META_PIXEL_ID, "InitiateCheckout", { value: icV, currency: icC, num_items: icN, content_ids: icIds, content_type: "product" });
        // GA4 begin_checkout is emitted only after Stripe Checkout mounts successfully.
        if (window.ttq) ttq.track("InitiateCheckout", { value: icV, currency: icC, content_type: "product" });
        if (window.clarity) { clarity("event", "checkout_opened"); clarity("set", "checkout_opened", "true"); }
      } catch (trackingError) {}

      buildOverlay();
      renderSummary(pmpCart);
      renderSuggestions(pmpCart);
      PMP_CUSTOMER_EMAIL = pmpValidEmail(PMP_CUSTOMER_EMAIL);
      await loadStripeJs();
      var pmpMountedCheckoutData = await mountCheckout(pmpCart);
      pmpTrackBeginCheckout(pmpCart, pmpMountedCheckoutData);
    } catch (e) {
      pmpTrackCheckoutError(pmpCheckoutSessionId ? "mount_checkout" : "create_checkout", e);
      closeOverlay();
      e.checkoutUnavailable = true;
      throw e;
    }
  }

  function pay(btn) {
    var label = btn.textContent; btn.disabled = true; btn.textContent = "Loading…";
    function reset() { btn.disabled = false; btn.textContent = label; }
    Promise.resolve(openEmbedded()).then(reset, function (e) { reset(); fallbackToShopifyCheckout(e); });
  }

  function selectedQuantity(form) {
    var scope = form.closest(".shopify-section") || form.closest("section") || document;
    var radio = scope.querySelector('input[type="radio"][name="quantity"]:checked');
    if (radio && parseInt(radio.value, 10) > 0) return parseInt(radio.value, 10);
    var qi = scope.querySelector('input[name="quantity"]:not([type="hidden"])') || form.querySelector('input[name="quantity"]');
    if (qi && parseInt(qi.value, 10) > 0) return parseInt(qi.value, 10);
    return 1;
  }

  async function buyNow(form, addBtn, btn) {
    btn.disabled = true; var label = btn.textContent; btn.textContent = PMP_T.adding;
    try {
      if (addBtn && addBtn.disabled) throw new Error("This product is currently unavailable.");
      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      var variantId = idInput && parseInt(idInput.value, 10);
      if (!variantId) throw new Error("Please select an option first.");
      var addRes = await fetch(pmpRoute("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: selectedQuantity(form) })
      });
      if (!addRes.ok) {
        var err = await addRes.json().catch(function () { return {}; });
        throw new Error(err.description || err.message || "Could not add this product to the cart.");
      }
      btn.textContent = "Loading…";
      await openEmbedded();
    } catch (e) {
      if (e && e.checkoutUnavailable) fallbackToShopifyCheckout(e);
      else alert(e.message || "Something went wrong.");
    }
    finally { btn.disabled = false; btn.textContent = label; }
  }

  function productAddButton(form) {
    var candidates = form.querySelectorAll('button[name="atlas-bundler-add"], [name="add"], button[type="submit"], input[type="submit"]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].offsetParent !== null && !candidates[i].classList.contains("pmp-buy-now") && !candidates[i].classList.contains("pmp-buy-now-stable")) return candidates[i];
    }
    return null;
  }

  function buyNowAnchor(addBtn) {
    return addBtn.closest(".buy-buttons-container") || addBtn;
  }

  function injectLearnMore() {
    var onCartPage = /\/cart\/?$/.test(location.pathname);

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var qa = form.closest("quick-add-component") || form.closest('[class*="quick-add"]');
      if (!qa) return;                                              // not a card → skip
      if (qa.querySelector(".pmp-learn-more, .pmp-card-add")) return; // already injected
      var card = qa.closest("product-card, .product-card, .card-wrapper, li") || qa.parentElement;

      var kind = qa.getAttribute ? qa.getAttribute("data-quick-add-button") : null;
      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      var vid = idInput && parseInt(idInput.value, 10);

      if (onCartPage && kind === "add" && vid) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "pmp-card-add"; b.textContent = PMP_T.add;
        b.addEventListener("click", function () { addFromCard(vid, b, cardMeta(card)); });
        qa.appendChild(b);
        return;
      }

      var link = card && card.querySelector('a[href*="/products/"]');
      var href = link && link.getAttribute("href");
      if (!href) return;                                 // no product URL → leave the card alone
      var a = document.createElement("a");
      a.className = "pmp-learn-more";
      a.href = href.split("?")[0];
      a.textContent = "Buy Now";
      qa.appendChild(a);
    });
  }

  function cardMeta(card) {
    if (!card) return { title: "", price: 0 };
    var t = card.querySelector('a[href*="/products/"]');
    var priceEl = card.querySelector('[class*="price"]');
    var price = 0;
    if (priceEl) {
      var m = String(priceEl.textContent).replace(/[\s,]/g, "").match(/(\d+(?:\.\d{1,2})?)/);
      if (m) price = parseFloat(m[1]) || 0;
    }
    return { title: t ? String(t.textContent).trim().slice(0, 90) : "", price: price };
  }

  async function addFromCard(variantId, btn, meta) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = PMP_T.adding;
    try {
      var r = await fetch(pmpRoute("cart/add.js"), {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!r.ok) throw new Error("Could not add this product.");
      try {
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
        if (window.fbq) fbq("trackSingle", META_PIXEL_ID, "AddToCart", {
          value: meta.price || undefined, currency: cur, content_type: "product",
          content_ids: [String(variantId)], content_name: meta.title || undefined
        });
        if (window.gtag) gtag("event", "add_to_cart", {
          currency: cur, value: meta.price || 0,
          items: [{ item_id: String(variantId), item_name: meta.title || "" }]
        });
        if (window.clarity) clarity("event", "cart_upsell_added");
      } catch (e) {}
      btn.textContent = PMP_T.added;
      location.reload();
    } catch (e) {
      btn.disabled = false; btn.textContent = label;
      alert(e.message || "Could not add this product.");
    }
  }

  function dedupeAddToCart() {
    if (location.pathname.indexOf("/products/") === -1) return;
    var kept = null;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.classList.contains("installment")) return;
      if (f.closest('[class*="quick-add"]')) return;   // recommendation cards
      if (f.closest('[class*="sticky-atc"]')) return;  // the theme's sticky bar is wanted
      var a = productAddButton(f);                     // visible buttons only
      if (!a) return;
      if (!kept) { kept = a; return; }                 // first visible one stays
      var box = a.closest("product-form") || a;        // hide the whole duplicate form
      if (box !== kept.closest("product-form")) box.style.display = "none";
    });
  }

  function inject() {
    injectLearnMore();
    dedupeAddToCart();

    document.querySelectorAll('[name="checkout"], a[href*="checkout"], [formaction*="checkout"]').forEach(function (a) {
      if (!isCheckoutControl(a)) return;
      a.style.setProperty("display", "none", "important");
      var host = a.parentElement;
      if (!host || host.querySelector(".pmp-pay-btn")) return;
      var b = document.createElement("button");
      b.type = "button"; b.className = "pmp-pay-btn"; b.textContent = "Buy Now";
      b.addEventListener("click", function () { pay(b); });
      host.insertBefore(b, a);
    });

    injectProductBuyNow();
  }

  function currentProductBuyTarget() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var form = null, add = null;
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.classList.contains("installment")) continue;   // Shop Pay installments
      if (f.closest('[class*="quick-add"]')) continue;
      if (f.closest('[class*="sticky-atc"]')) continue;
      var a = productAddButton(f);                          // visible buttons only
      if (!a) continue;
      if (a.className && a.className.indexOf("quick-add") !== -1) continue;
      var section = f.closest(".shopify-section");
      var isMain = !!(section && /__main\b/.test(section.id || ""));
      var isBundleApp = a.getAttribute("name") === "atlas-bundler-add";
      if (!isMain && !isBundleApp) continue;
      form = f; add = a; break;                             // first visible one wins
    }
    return form ? { form: form, add: add } : null;
  }

  function ensurePaymentCards(button) {
    var next = button.nextElementSibling;
    if (!next || !next.classList.contains("pmp-cards-stable")) {
      var cards = document.createElement("div");
      cards.className = "pmp-cards-stable";
      cards.innerHTML = PMP_CARD_LOGOS;
      button.insertAdjacentElement("afterend", cards);
    }
  }

  function placeProductExtrasAfterBuyNow(button) {
    var tail = button.nextElementSibling && button.nextElementSibling.classList.contains("pmp-cards-stable")
      ? button.nextElementSibling : button;
    ["pmp-shipping-banner", "pmp-guarantee-badge"].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      tail.insertAdjacentElement("afterend", el);
      tail = el;
    });
  }

  function injectProductBuyNow() {
    if (location.pathname.indexOf("/products/") === -1) return;

    // Once a live button exists, never move or recreate it. Bundle applications
    // continuously rebuild their forms; following each rebuild made the button
    // jump between containers and replaced its click handler.
    var existing = document.querySelector(".pmp-buy-now-stable");
    if (existing && existing.isConnected) {
      ensurePaymentCards(existing);
      placeProductExtrasAfterBuyNow(existing);
      return;
    }

    var target = currentProductBuyTarget();
    if (!target) return;
    var form = target.form, add = target.add;

    // Mount OUTSIDE <product-form>. Atlas replaces the form when bundle choices
    // change; a sibling survives those replacements and therefore cannot dance.
    var anchor = form.closest("product-form") || form;
    var host = anchor.parentElement || form.parentElement;

    var b = host && host.querySelector(":scope > .pmp-buy-now-stable");
    if (!b) {
      b = document.createElement("button");
      b.type = "button"; b.className = "pmp-pay-btn pmp-buy-now-stable"; b.textContent = "Buy Now";
      anchor.insertAdjacentElement("afterend", b);
    }
    ensurePaymentCards(b);
    placeProductExtrasAfterBuyNow(b);
  }

  // Delegation resolves the CURRENT bundle form at click time, so a form
  // replaced by the bundle app cannot leave the visible button with a stale
  // handler. The window guard also prevents duplicate handlers if Shopify
  // re-evaluates this section.
  if (!window.__pmpBuyNowV4Delegated) {
    window.__pmpBuyNowV4Delegated = true;
    document.addEventListener("click", function (e) {
      var button = e.target && e.target.closest ? e.target.closest(".pmp-buy-now-stable") : null;
      if (!button) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (button.disabled) return;
      var target = currentProductBuyTarget();
      if (!target) { alert("The product form is not ready yet. Please try again."); return; }
      buyNow(target.form, target.add, button);
    }, true);
  }

  var pmpInjectTimer = null;
  function scheduleInject() {
    if (pmpInjectTimer) return;
    pmpInjectTimer = setTimeout(function () {
      pmpInjectTimer = null;
      inject();
    }, 180);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleInject, { once: true });
  } else {
    scheduleInject();
  }
  new MutationObserver(scheduleInject).observe(document.documentElement, { childList: true, subtree: true });
})();
